import React, { ReactNode } from 'react';
import classNames from 'classnames';

interface StyleType {
  [key: string]: any;
}

export interface BadgeProps {
  testId?: string;
  label?: string;
  size?: 'sm' | 'lg';
  type?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'warning'
    | 'success'
    | 'info';
  dot?: boolean;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  className?: string;
  none?: boolean;
  style?: StyleType;
}

const Badge = ({
  testId,
  label,
  type = 'default',
  size,
  dot,
  startIcon,
  endIcon,
  className,
  none,
  style,
}: BadgeProps) => {
  if (!label) return null;
  return (
    <div
      data-testid={testId}
      className={classNames(
        'badge',
        `badge-${type}`,
        'rounded-pill',
        `badge-${size}`,
        { 'badge-none': none },
        className,
      )}
      style={style}
    >
      {dot && !startIcon && <div className="badge-dot" />}
      {startIcon && startIcon}
      {label}
      {endIcon && endIcon}
    </div>
  );
};

export default Badge;
